import type { PersonalPageSubtype } from '../../subtypes';
import type { PersonalPageCapabilities } from '../types';
import { campaignCapabilities } from './campaign';
import { eventCapabilities } from './event';
import { informationCapabilities } from './information';

export const SUBTYPE_CAPABILITIES: Record<PersonalPageSubtype, PersonalPageCapabilities> = {
  ...campaignCapabilities,
  ...eventCapabilities,
  ...informationCapabilities
} as Record<PersonalPageSubtype, PersonalPageCapabilities>;
